<template>
    <div>
        <div v-if="authUserPermission['plant-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col-7">
                                <h3 class="mb-0">{{ tt('plant_code') }}</h3>
                            </div>
                            <div class="col-5">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_plant_code')" v-on:keyup="filter"/>                            
                                </div>
                            </div>
                           <!--  <div class="col text-right">
                                <base-button size="sm" type="default" @click="create" v-if="authUserPermission['plant-create']">{{ tt('add_new') }}</base-button>
                            </div> -->
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('client')" :prop="tt('client')" min-width="130px" sortable>
                                <template v-slot="{row}">
                                    {{row.client_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('company')" :prop="tt('company')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.company_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('plant')" :prop="tt('plant')" min-width="120px" sortable>
                                <template v-slot="{row}">
                                    {{row.plant_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('description')" :prop="tt('description')" min-width="220px" sortable>
                                <template v-slot="{row}">
                                    {{row.description}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('profit_center')" :prop="tt('profit_center')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.profit_center_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('city')" :prop="tt('city')" min-width="100px" sortable>
                                <template v-slot="{row}">
                                    {{row.city}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('address')" :prop="tt('address')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.address}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('po_box')" :prop="tt('po_box')" min-width="120px" sortable>
                                <template v-slot="{row}">
                                    {{row.po_box}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('postal_code')" :prop="tt('postal_code')" min-width="160px" sortable>
                                <template v-slot="{row}">
                                    {{row.postal_code}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                  <!--   <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true" v-if="authUserPermission['plant-update'] || authUserPermission['plant-delete']">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'edit', data:row.id}" v-if="authUserPermission['plant-update']">{{ tt('edit') }}</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}" v-if="authUserPermission['plant-delete']">{{ tt('delete') }}</el-dropdown-item>                                        
                                        </el-dropdown-menu>
                                    </el-dropdown> -->
                                </template>
                            </el-table-column>
                        </el-table>
                        <page-loading v-else/>
                    </div>
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>

                        <label class="form-control-label">{{ tt('holding') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('holding')" rules="required">
                            <el-select class="select-danger" v-model="plantCode.client_code" :placeholder="tt('choose_holding')">
                                <el-option class="select-danger" :value="hc['client_code']" :label="hc['client_code'] + ' - ' + hc['client_name']" :key="hc['client_code'] + ' - ' + hc['client_name']" v-for="hc in  holdingCode"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('company') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('company')" rules="required">
                            <el-select class="select-danger" v-model="plantCode.company_code" :placeholder="tt('choose_company')">
                                <el-option class="select-danger" :value="cc['company_code']" :label="cc['company_code'] + ' - ' + cc['company_description']" :key="cc['company_code'] + ' - ' + cc['company_description']" v-for="cc in companyCode"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('plant') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('plant')" :placeholder="tt('plant')" v-model="plantCode.plant_code" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('description') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('description')" :placeholder="tt('description')" v-model="plantCode.description" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('profit_center') }}</label>
                        <base-input :name="tt('profit_center')">
                            <el-select class="select-danger" v-model="plantCode.profit_center_code" :placeholder="tt('choose_company')">
                                <el-option class="select-danger" :value="pc['profit_center_code']" :label="pc['profit_center_code'] + ' - ' + pc['profit_center_description']" :key="pc['profit_center_code'] + ' - ' + pc['profit_center_description']" v-for="pc in profitCenter"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('city') }}</label>
                        <base-input :name="tt('city')" :placeholder="tt('city')" v-model="plantCode.city"></base-input>

                        <label class="form-control-label">{{ tt('address') }}</label>
                        <base-input :name="tt('address')" :placeholder="tt('address')" v-model="plantCode.address"></base-input>

                        <label class="form-control-label">{{ tt('po_box') }}</label>
                        <base-input :name="tt('po_box')" :placeholder="tt('po_box')" v-model="plantCode.po_box"></base-input>

                        <label class="form-control-label">{{ tt('postal_code') }}</label>
                        <base-input :name="tt('postal_code')" :placeholder="tt('postal_code')" v-model="plantCode.postal_code"></base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import plantCode from '@/services/master/plantCode.service';
    import holdingCode from '@/services/master/holdingCode.service';
    import companyCode from '@/services/master/companyCode.service';
    import profitCenter from '@/services/master/profitCenter.service';

    export default {        
        data() {
            return {              
                onLoad: true,      
                loadTimeout: null,  
                btnSave: {
                    onLoading: false
                },                  
                form: {
                    add: true,
                    title: this.tt('add_plant_code'),
                    show: false
                },     
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },     
                errorMessage: null,   
                plantCode: {},
                holdingCode: {},
                companyCode: {},
                profitCenter: {},
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
            this.getHoldingCode()
            this.getCompanyCode()
            this.getProfitCenter()
        },
        methods: {
            get() { 
                let context = this;               
                Api(context, plantCode.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data = response.data.data.data.data; 
                    context.table.page  = response.data.data.data;  
                    context.onLoad = false;          
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            getHoldingCode() {
                let context = this;               
                Api(context, holdingCode.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.holdingCode = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.holdingCode = [];
                    }
                })
                .call()
            },
            getCompanyCode() {
                let context = this;               
                Api(context, companyCode.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.companyCode = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.companyCode = [];
                    }
                })
                .call()
            },
            getProfitCenter() {
                let context = this;               
                Api(context, profitCenter.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.profitCenter = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.profitCenter = [];
                    }
                })
                .call()
            },
            filter() {
                this.onLoad = true;
                this.table.page.current_page = 1;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('add_plant_code');
                this.form.show = true;
                this.plantCode = {
                    'client_code': '',
                    'company_code': '',
                    'plant_code': '',
                    'description': '',
                    'profit_center_code': '',
                    'city': '',
                    'address': '',
                    'po_box': '',
                    'postal_code': '',
                };
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, plantCode.show(id)).onSuccess(function(response) {
                    context.plantCode = response.data.data;
                    context.form.add = false;
                    context.form.title = context.tt('edit_plant_code');
                    context.form.show = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, plantCode.create(this.plantCode));
                } else {{
                    api = Api(context, plantCode.update(this.plantCode.id, this.plantCode));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, plantCode.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
        }   
    };
</script>
<style></style>
